import React, { createContext, useContext, useState, useCallback } from 'react';

type NavbarToolbarContextValue = {
  toolbar: React.ReactNode | null;
  setToolbar: (content: React.ReactNode | null) => void;
};

export const NavbarToolbarContext = createContext<NavbarToolbarContextValue | null>(null);

export function NavbarToolbarProvider({ children }: { children: React.ReactNode }) {
  const [toolbar, setToolbarState] = useState<React.ReactNode | null>(null);
  const setToolbar = useCallback((content: React.ReactNode | null) => {
    setToolbarState(() => content);
  }, []);

  return (
    <NavbarToolbarContext.Provider value={{ toolbar, setToolbar }}>
      {children}
    </NavbarToolbarContext.Provider>
  );
}

export function useNavbarToolbar() {
  const ctx = useContext(NavbarToolbarContext);
  if (!ctx) {
    throw new Error('useNavbarToolbar must be used within NavbarToolbarProvider');
  }
  return ctx;
}
